import * as React from 'react'
import TableBody from '@mui/material/TableBody'
import TableRow from '@mui/material/TableRow'
import Skeleton from '@mui/material/Skeleton'
import {
  StyledUserNameAndMainColumn,
  StyledTableCell,
} from '../components'

const DEFAULT_ROW_COUNT = 5

const SkeletonCell = ({ width }) => (
  <Skeleton variant="text" width={width} height={24} />
)

const UserContractsTableBodySkeleton = React.memo(
  ({ rowCount = DEFAULT_ROW_COUNT }) => {
    const rows = React.useMemo(
      () => Array.from({ length: Math.max(1, rowCount) }),
      [rowCount]
    )

    return (
      <TableBody aria-busy="true" aria-live="polite">
        {rows.map((_, idx) => {
          const isLast = idx === rows.length - 1
          return (
            <TableRow
              key={`user-contracts-skeleton-row-${idx}`}
              sx={{
                borderBottom: isLast ? '2px solid' : '1px solid',
                color: (theme) => theme.tokens.secondary,
                backgroundColor: 'transparent',
              }}
            >
              <StyledUserNameAndMainColumn
                sx={{
                  borderRight: '1px solid rgba(224, 224, 224, 1)',
                  width: '17%',
                  textAlign: 'center',
                  verticalAlign: 'middle',
                }}
              >
                <Skeleton
                  variant="text"
                  width="60%"
                  height={24}
                  sx={{ mx: 'auto' }}
                />
              </StyledUserNameAndMainColumn>
              <StyledTableCell style={{ width: '14%' }}>
                <SkeletonCell width="85%" />
              </StyledTableCell>
              <StyledTableCell style={{ width: '12%' }}>
                <SkeletonCell width="70%" />
              </StyledTableCell>
              <StyledTableCell style={{ width: '14%' }}>
                <SkeletonCell width="80%" />
              </StyledTableCell>
              <StyledTableCell style={{ width: '12%' }}>
                <SkeletonCell width="60%" />
              </StyledTableCell>
              <StyledTableCell style={{ width: '12%' }}>
                <SkeletonCell width="65%" />
              </StyledTableCell>
              <StyledTableCell style={{ width: '19%' }}>
                <SkeletonCell width="40%" />
              </StyledTableCell>
            </TableRow>
          )
        })}
      </TableBody>
    )
  }
)

UserContractsTableBodySkeleton.displayName = 'UserContractsTableBodySkeleton'

export default UserContractsTableBodySkeleton
